var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal-action-" + _vm.action,
      attrs: {
        id: "modal-action-" + _vm.action,
        title: _vm.title + " documento",
        "data-cy": "modal-action-document",
        "ok-title": "Cerrar",
        "ok-only": "",
        size: "lg"
      },
      on: { ok: _vm.cancelProcess, close: _vm.cancelProcess }
    },
    [
      _c("div", { staticClass: "mt-2" }, [
        _vm._v(" Estamos intentando abrir el documento para su edición ")
      ]),
      _c("div", { staticClass: "mt-2" }, [
        _vm._v(
          " Recuerda no cerrar y aprobar el documento hasta haber terminado de editarlo y guardarlo "
        )
      ]),
      _c("div", { staticClass: "mt-2 alert-warning" }, [
        _vm._v(
          " Cuando cierres este panel, se recargara la vista para ver el documento actualizado "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }